// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"1f232c82","58":"b391382d","156":"262291b3","194":"dc279643","372":"7f55f966","480":"41241286","493":"3411ef74","602":"a1b820e3","818":"a775838c"}[chunkId] + ".chunk.js";
};